export const PHONE_CHANNEL_FORMATS = Object.freeze([
  "x-xxx-xxx-xxxx",
  "xxx-xxxx",
  "xx-xx-xx",
  "xxxx-xxxx",
  "xx-xxxx-xxxx",
  "xx-xx-xx-xx-xx",
  "xxxx-xxxx-xxxx",
  "xx-x-xxxxxxxxxx",
  "xxx-xxx-xxxx",
  "xx-xxxxxxxx",
  "xx-xxxxxxxxx",
  "xx-xxxxxxxxxx",
  "xx-xxxxxxxxxxx",
  "xxx-xxxxxxxx",
  "xxx-xxxxxxxxx",
  "xxx-xxxxxxxxxx",
  "xx-xxxxxxxxxxxx",
  "xx-xxxxxxxxxxxxx",
  "xx-xxxxxxxxxxxxxx",
  "xx-xxxxxxxxxxxxxxx",
  "xxx-xxxxxxxxxxx",
  "xxx-xxxxxxxxxxxx",
  "xxx-xxxxxxxxxxxxx",
  "xxx-xxxxxxxxxxxxxx",
  "xxx-xxxxxxxxxxxxxxx",
]);

export const PHONE_CHANNEL_TYPES = Object.freeze({
  AGENT_EXTENSION: "agentExtension",
  AGENT_DID: "agentDID",
  TENANT: "tenant",
});
